import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
// import { Geolocation } from '@ionic-native/geolocation/ngx';
// import { Camera } from '@ionic-native/camera/ngx';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TermsOfServicePage } from './terms-of-service/terms-of-service.page';
import { PrivacyPolicyPage } from './privacy-policy/privacy-policy.page';
import { VehiclesService } from './vehicles/vehicles.service';
import { IncidentsService } from './incidents/incidents.service';
import { HtmlToPlaintextPipe } from './pipes/html-to-plaintext.pipe';
import { PipesModule } from './pipes/pipes.module';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function appInit(vehiclesService: VehiclesService,incidentService: IncidentsService) {
  incidentService.loadData();
  return () => vehiclesService.loadData();
}

// //TRY
// export function appInit(incidentService: IncidentsService) {
//   return () => incidentService.loadData();
// }

@NgModule({
  declarations: [AppComponent,  TermsOfServicePage, PrivacyPolicyPage],
  entryComponents: [TermsOfServicePage, PrivacyPolicyPage],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    PipesModule
  ],
  providers: [
    //StatusBar,
    //SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    VehiclesService,
    {
      provide: APP_INITIALIZER,
      useFactory: 
        appInit,
        // appInit2,
      multi: true,
      deps: [
        VehiclesService,
        IncidentsService
      ]      
    },
    IncidentsService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
